import React, { Component } from "react"
// import { useHistory } from 'react-router-dom';
// import axios from 'axios';

export class Hero extends Component {
	state = { city: null }

	componentDidMount() {
		switch (this.props.campus) {
			case "txau":
				this.setState({ city: "Austin, Texas" })
				break
			case "txda":
				this.setState({ city: "Dallas, Texas" })
				break
			case "casm":
				this.setState({ city: "San Marcos, California" })
				break
			case "flmi":
				this.setState({ city: "Miami, Florida" })
				break
			case "flsa":
				this.setState({ city: "St. Augustine, Florida" })
				break
			default:
				this.setState({ city: "USAHS" })
				break
		}
	}

	render() {
		let { city } = this.state

		return (
			<>
				<div
					id="hero"
					className={this.props.campus}
				>
					<div className="container">
						<div className="row">
							<div className="col-7">
								<h1>
									<span>{city}</span>
									{this.props.title}
								</h1>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}
}

export default Hero
